@if (pdfData() && !error()) {
  <div class="w-full h-full">
    <embed class="w-full h-full" name="plugin" [src]="pdfData()" type="application/pdf"/>
  </div>
}

@if (error()) {
  <div id="error" class="text-3xl font-bold text-center">
    {{error()}}
  </div>
}